import { render, staticRenderFns } from "./LsContentPlaceholder.vue?vue&type=template&id=6d3c7b60&scoped=true&"
import script from "./LsContentPlaceholder.vue?vue&type=script&lang=js&"
export * from "./LsContentPlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./LsContentPlaceholder.vue?vue&type=style&index=0&id=6d3c7b60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3c7b60",
  null
  
)

export default component.exports